export default (axios, baseURL) => async (clientSid, samlIdpInfo) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/external-idp-saml`;

  const axiosConfig = {
    method: 'POST',
    baseURL,
    url,
    data: { samlIdpInfo }
  };

  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
